"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.AppMenuDropdown = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _reactOnclickoutside = _interopRequireDefault(require("react-onclickoutside"));

var _classnames = _interopRequireDefault(require("classnames"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var ToggleButton = function ToggleButton(props) {
  var title = props.title,
      caret = props.caret;
  return /*#__PURE__*/_react.default.createElement("a", {
    className: (0, _classnames.default)('ModuleNavigation-dropdown dropdown-toggle justify-content-between', {
      inactive: !caret
    }),
    role: "button",
    id: "basic-nav-dropdown"
  }, /*#__PURE__*/_react.default.createElement("span", null, title), caret && /*#__PURE__*/_react.default.createElement("span", {
    className: "caret"
  }));
};

var DropdownMenu = function DropdownMenu(props) {
  var children = props.children;

  if (!children && !children.length) {
    return null;
  }

  return /*#__PURE__*/_react.default.createElement("ul", {
    role: "menu",
    className: "dropdown-menu"
  }, children);
};
/*
 * The onClickOutside HOC cannot be on the top level anymore as we have to provide
 * handleClickOutside as prop.
 */


var AppMenuDropdownOpener = (0, _reactOnclickoutside.default)(function (props) {
  var showAsOpen = props.showAsOpen,
      children = props.children,
      onDropdownClick = props.onDropdownClick;
  return /*#__PURE__*/_react.default.createElement("li", {
    className: (0, _classnames.default)('dropdown', {
      open: showAsOpen
    }),
    onClick: onDropdownClick
  }, children);
});

var AppMenuDropdown = function AppMenuDropdown(props) {
  var title = props.title,
      caret = props.caret,
      children = props.children;

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      isOpen = _useState2[0],
      setIsOpen = _useState2[1];

  var handleDropdownClick = function handleDropdownClick() {
    return setIsOpen(!isOpen);
  };

  var handleClickOutside = function handleClickOutside() {
    setIsOpen(false);
  };

  var openWithChildren = children && children.length && isOpen;
  return /*#__PURE__*/_react.default.createElement(AppMenuDropdownOpener, {
    showAsOpen: openWithChildren,
    onDropdownClick: handleDropdownClick,
    handleClickOutside: handleClickOutside
  }, /*#__PURE__*/_react.default.createElement(ToggleButton, {
    title: title,
    caret: caret
  }), /*#__PURE__*/_react.default.createElement(DropdownMenu, null, children));
};

exports.AppMenuDropdown = AppMenuDropdown;
var _default = AppMenuDropdown;
exports.default = _default;
AppMenuDropdown.defaultProps = {
  caret: false
};
AppMenuDropdown.propTypes = {
  title: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.element]).isRequired,
  caret: _propTypes.default.bool
};